import { Box, Button, Card, Collapse, Grid } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";

import ActiveFilters from "../ActiveFilters";

import FilterItems from "./FilterItems";
import { useBay } from "../../../Hooks/useBay";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
  orderStatus,
  type,
}) => {
  const { bays } = useBay();

  // All filters in the order they appear
  const activeFilterDefinitions = [
    // Standard filters - in order
    {
      type: "standard",
      id: "sssJobNo",
      label: "SSS Job No",
      value: submittedData.sssJobNo,
    },
    {
      type: "standard",
      id: "custOrder",
      label: "Cust Order",
      value: submittedData.custOrder,
    },
    {
      type: "standard",
      id: "customer",
      label: "Customer",
      value: submittedData.customer,
    },
    {
      type: "dateRange",
      id: "orderDate",
      label: "Order Date",
      startValue: submittedData.orderDateStart,
      endValue: submittedData.orderDateEnd,
      startField: "orderDateStart",
      endField: "orderDateEnd",
    },
    {
      type: "standard",
      id: "picker",
      label: "Picker",
      value: submittedData?.picker,
    },
    {
      type: "standard",
      id: "freightLineOrder",
      label: "Freight Line Order",
      value: submittedData.freightLineOrder,
    },
    {
      type: "standard",
      id: "bay",
      label: "Bay",
      value: submittedData.bay
        ? bays.find((b) => b.bay_code === submittedData.bay)?.bay_name || ""
        : "",
    },
    {
      type: "standard",
      id: "status",
      label: "Status",
      value:
        orderStatus?.find((b) => b.code === submittedData?.status)?.name ||
        submittedData?.status,
    },
    {
      type: "standard",
      id: "git",
      label: "Git",
      value: submittedData?.git,
    },
    {
      type: "dateRange",
      id: "cutoff",
      label: "Cutoff",
      startValue: submittedData.cutoffStart,
      endValue: submittedData.cutoffEnd,
      minField: "cutoffMin",
      maxField: "cutoffMax",
    },
    {
      type: "numericRange",
      id: "orderLine",
      label: "Order Line",
      minValue: submittedData.orderLineMin,
      maxValue: submittedData.orderLineMax,
      minField: "orderLineMin",
      maxField: "orderLineMax",
    },
    {
      type: "numericRange",
      id: "pickUpQty",
      label: "Pick Up Qty",
      minValue: submittedData.pickUpQtyMin,
      maxValue: submittedData.pickUpQtyMax,
      minField: "pickUpQtyMin",
      maxField: "pickUpQtyMax",
    },
  ];

  const handleRemoveDateRange = (field) => {
    handleRemove(field);
  };

  const handleRemoveNumericRange = (field) => {
    handleRemove(field);
  };

  return (
    <Box sx={{ marginBottom: "24px" }}>
      <Grid item xs={12}>
        <Collapse in={filterOpen}>
          <Card>
            <Box p={4}>
              <FilterItems
                filterData={filterData}
                handleChangeFilter={handleChangeFilter}
                handleFilter={handleFilter}
                handleClearFilters={handleClearFilters}
                orderStatus={orderStatus}
                type={type}
                bays={bays}
              />
              <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  sx={{ mr: 1, color: "#7152F3" }}
                >
                  Clear
                </Button>
                <Button
                  variant="contained"
                  onClick={handleFilter}
                  sx={{ backgroundColor: "#7152F3" }}
                >
                  Filter{" "}
                  <ArrowForward
                    fontSize="small"
                    style={{
                      marginLeft: "5px",
                    }}
                  />
                </Button>
              </Box>
            </Box>
          </Card>
        </Collapse>
      </Grid>
      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
        onRemoveDateRange={handleRemoveDateRange}
        onRemoveNumericRange={handleRemoveNumericRange}
      />
    </Box>
  );
};

export default Filter;
